<div>
    <ppl-accordion [title]="'Prospective Consumer Information'" [isOpen]="true"
        *authorize="[pageId, tabId, 'Demographics', 'section']">
        <ppl-prospective-info [gridData]="filledInfo" [sectionData]="steps" [entry]="entry" [selectedLead]="selectedLead" [program]="program" [pageId]="pageId" [tabId]="tabId" (leadUpdated)="updatedLeadData($event)"></ppl-prospective-info>
    </ppl-accordion>
</div>